import React from "react";
import Logo from "../../../../assets/landing/medellin.png";
// style components
import { Image, Divider } from "antd";

export const HeaderLogin = () => {
  return (


    <div className="row">
      <div className="col-12 justify-content-center padding-bottom-3">
        <Image src={Logo} preview={false} className="img-fluid image-size mx-auto"  />
      </div>
      <div className="col-12 font-color-005CC6 font-size-18px font-family-Montserrat-Bold text-center padding-bottom-5">
        Secretaría de Cultura Ciudadana, convocatorias de fomento y <br></br> estímulos para el arte y la cultura
      </div>
      <Divider style={{ marginTop: "1%" }} />
      <div className="col-12 font-size-14px font-family-Montserrat-Bold padding-bottom-5">
        Ingresa tus datos para iniciar sesión
      </div>
    </div>

  );
};